export const API_ENDPOINTS = {
  login: {
    loginEmployee: () => `users/auth/login`,
  },
  forgotPassword: {
    forgotPassword: (empId) => `/forgot-password/getEmailId?empId=${empId}`,
  },
  forgotPasswordMail: {
    forgotPasswordMail: () => `/forgot-password`,
  },
  resetPassword: {
    resetPassword: () => `/forgot-password/change-Password`,
  },
  microsoftLogin: {
    microsoftLogin: () => `/users/microsoft/login`,
  },
};
